import { styled } from 'storybook/theming';

export const InformationBanner = styled.p`
  background: #ffebba;
  padding: 5px;
  margin-top: 0;
`;
